import { Card, Progress } from "@peer-start/ui/reducate";
import { useTranslation } from "react-i18next";
import {
  competencyCompletion,
  routeCompletion,
  type CompetencyRef,
  type StartingTeacherProgress,
} from "../data/starting-teacher-route.js";

export function StartingTeacherLevelProgress({
  progress,
  competency,
}: {
  progress: StartingTeacherProgress;
  competency?: CompetencyRef;
}) {
  const { t } = useTranslation();
  const counts = competency ? competencyCompletion(competency, progress) : routeCompletion(progress);
  const percent = counts.total === 0 ? 0 : Math.round((counts.done / counts.total) * 100);
  const caption = t(
    competency ? "startingTeacher.competencyProgressCount" : "startingTeacher.routeProgressCount",
    counts,
  );

  return (
    <Card
      data-control-id={
        competency ? "starting-teacher.competency-progress" : "starting-teacher.route-progress"
      }
    >
      <h2 className="text-sm font-medium">{t("startingTeacher.totalProgress")}</h2>
      <p className="mt-5 text-[32px] leading-none font-medium tracking-tight tabular-nums">{percent}%</p>
      <Progress aria-label={caption} className="mt-5" value={percent} />
      <p className="mt-4 text-sm text-muted-foreground">{caption}</p>
    </Card>
  );
}
